import CreditBadge from "pages/Front/Booking/Credits/components/CreditBadge";
import React from "react";
import {useTranslation} from "react-i18next";

const PackageCreditBadge = () => {
    const {t} = useTranslation();
    return (
        <div className={"PackageCreditBadge flex flex-col items-center"}>
            <div className={"flex flex-row items-center justify-center space-x-2 mb-2"}>
                <img src="/img/credits/arbo-credits-icon.svg" alt="credits icon" className="w-[40px] h-[40px] flex-none" />
                <span className={"font-bold text-2xl text-black"}>{t("Credits")}</span>
                <CreditBadge title={t("Optional")} color={"bg-arbo-red"} />
            </div>
        </div>
    );
};

export default PackageCreditBadge;
